/* ==========================================================================
   Maccs — Club plan tiles
   Two plan tiles on the PDP. Picking one deselects the other; clicking a
   selected tile clears it, so adding nothing stays reachable. The chosen
   variant is written to a hidden input and added as a second line item
   after Envy's own add completes.

   Oct 2026: member price syncing removed along with member pricing. The
   archived markup lives in snippets/mx-hearts-ledger-archive.liquid.
   ========================================================================== */

(function () {
  'use strict';

  var store = document.querySelector('[data-mx-club-add]');
  var tiles = document.querySelectorAll('[data-mx-club-tile]');
  var purchase = document.getElementById('purchase');
  if (!store || !tiles.length) return;
  if (!purchase) return;

  var $ = window.jQuery;

  /* --- tile selection ----------------------------------------------------- */

  Array.prototype.forEach.call(tiles, function (tile) {
    tile.addEventListener('click', function () {
      var wasOn = tile.getAttribute('aria-pressed') === 'true';

      Array.prototype.forEach.call(tiles, function (t) {
        t.setAttribute('aria-pressed', 'false');
      });

      if (wasOn) {
        store.value = '';
      } else {
        tile.setAttribute('aria-pressed', 'true');
        store.value = tile.dataset.variantId || '';
      }
    });
  });

  function clearSelection() {
    Array.prototype.forEach.call(tiles, function (t) {
      t.setAttribute('aria-pressed', 'false');
    });
    store.value = '';
  }

  /* --- add membership after Envy's own add --------------------------------
     Envy posts the main item via jQuery $.ajax. Firing our add at the same
     moment makes Shopify reject one of the two writes with a 422, so we wait
     for Envy's request to finish and then queue ours behind it.
     ------------------------------------------------------------------------ */

  var armed = '';      /* variant id chosen when Add to Cart was pressed */
  var adding = false;  /* our own request is in flight — ignore it below  */

  /* Read intent at click time. The selection may change before the add
     completes, and we honour what the customer chose when they pressed. */
  purchase.addEventListener('click', function () {
    armed = store.value || '';
  });

  if (!$) return;

  $(document).ajaxComplete(function (event, xhr, settings) {
    var url = (settings && settings.url) || '';
    if (url.indexOf('/cart/add') === -1) return;

    /* Ignore our own add, and any add fired with no plan selected. */
    if (adding || !armed) return;

    /* Envy's add failed, so there is nothing to attach the membership to. */
    if (xhr.status < 200 || xhr.status >= 300) { armed = ''; return; }

    var variantId = parseInt(armed, 10);
    armed = '';
    if (!variantId) return;

    adding = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Membership add failed: ' + r.status);
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Repaint the drawer so the membership appears alongside the item
           Envy already rendered. */
        if (window.MM && typeof window.MM.update_cart_drawer === 'function') {
          window.MM.update_cart_drawer(cart);
        }
        clearSelection();
      })
      .catch(function (err) {
        console.error('[maccs-club]', err);
      })
      .then(function () { adding = false; });
  });
})();